export enum KnownAuth0Roles {
  Admin = "Admin",
  Closer = "Closer",
}
